import { Loader2, Brain } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export function AnalysisProcessing() {
  const { t } = useTranslation('analysis');

  return (
    <Card className="bg-muted/30 border-dashed sketch-border">
      <CardContent className="flex flex-col items-center justify-center py-12 text-center">
        <div className="rounded-full bg-primary/10 p-4 mb-4 relative">
          <Brain className="h-8 w-8 text-primary" />
          <Loader2 className="h-4 w-4 text-primary absolute -bottom-1 -right-1 animate-spin" />
        </div>
        <h3 className="text-lg font-bold mb-2">
          {t('status.processing')}
        </h3>
        <p className="text-muted-foreground text-sm max-w-sm mb-4">
          {t('messages.aiProcessing')}
        </p>
        <div className="w-48 h-1 bg-muted rounded-full overflow-hidden">
          <div className="h-full bg-primary/60 animate-pulse" style={{ width: '60%' }} />
        </div>
      </CardContent>
    </Card>
  );
}
